import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '@firsttable/web-theme';
import Box, { BoxStyleProps } from '../Box';

const StyledContainer = styled(Box)`
  position: relative;
  box-sizing: content-box;
`;

const containerDefaultPl = ['s', 'm'];
const containerDefaultPr = ['s', 'm'];
const Container = ({
  pl = containerDefaultPl,
  pr = containerDefaultPr,
  mx = 'auto',
  maxWidth = breakpoints.l,
  ...props
}: BoxStyleProps) => (
  <StyledContainer pl={pl} pr={pr} mx={mx} maxWidth={maxWidth} {...props} />
);

Container.propTypes = {
  pl: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
  pr: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
  mx: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
  maxWidth: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default Container;
